<template>
  <div id="page-user-edit">
    <vs-alert
      color="danger"
      title="User Not Found"
      :active.sync="user_not_found"
    >
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span
        ><router-link
          :to="{ name: 'page-user-list' }"
          class="text-inherit underline"
          >All Users</router-link
        >
      </span>
    </vs-alert>

    <vx-card v-if="user_data" class="pb-10">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <div id="user-edit-tab-info">
            <div class="vx-row mt-10">
              <div class="vx-col w-full md:w-1/2">
                <div class="flex items-end">
                  <feather-icon
                    icon="UserIcon"
                    class="mr-2"
                    svgClasses="w-5 h-5"
                  />
                  <span class="leading-none font-medium"
                    >Personal Information</span
                  >
                </div>
              </div>
            </div>

            <div class="vx-row mt-0">
              <div class="vx-col w-full md:w-1/2">
                <div>
                  <vs-input
                    class="w-full mt-4"
                    label="First Name"
                    v-model="user_data.first_name"
                    v-validate="'required|alpha_spaces'"
                    name="first name"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('first name')"
                    >{{ errors.first("first name") }}</span
                  >

                  <vs-input
                    class="w-full mt-4"
                    label="Last Name"
                    v-model="user_data.last_name"
                    v-validate="'required|alpha_spaces'"
                    name="last name"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('last name')"
                    >{{ errors.first("last name") }}</span
                  >

                  <vs-input
                    class="w-full mt-4"
                    type="password"
                    label="Password"
                    v-model="user_data.password"
                    v-validate="'required'"
                    name="password"
                  />

                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('password')"
                    >{{ errors.first("password") }}</span
                  >
                </div>
              </div>

              <div class="vx-col w-full md:w-1/2">
                <vs-input
                  class="w-full mt-4"
                  label="Email"
                  v-model="user_data.email"
                  type="email"
                  v-validate="'required|email'"
                  name="email"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('email')"
                  >{{ errors.first("email") }}</span
                >

                <div class="mt-4">
                  <label class="vs-input--label">Role</label>
                  <v-select
                    v-model="user_data.role"
                    :clearable="false"
                    :options="roleOptions"
                    v-validate="'required'"
                    name="role"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('role')"
                    >{{ errors.first("role") }}</span
                  >
                </div>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                  <vs-button
                    class="ml-auto mt-2"
                    @click.prevent="save_changes"
                    :disabled="!validateForm"
                    >Save Changes</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    vSelect,
    flatPickr,
  },
  data() {
    return {
      user_data: {
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        role: null,
      },

      user_not_found: false,

      roleOptions: [
        { label: "Admin", value: "Admin" },
        { label: "Caissier(e)", value: "Caissier(e)" },
      ],
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    capitalize_snake(str) {
      return (str.slice(0, 1).toUpperCase() + str.slice(1, str.length))
        .split("_")
        .join(" ");
    },
    save_changes() {
      this.$validator.validateAll().then((result) => {
        this.user_data.role = this.user_data.role.value;
        if (result) {
          this.$store
            .dispatch("ADD_USER", this.user_data)
            .then(() => {
              this.$vs.notify({
                title: "Success",
                text: "Client ajouté avec succès",
                color: "success",
                position: "top-center",
              });
            })
            .catch(() => {
              this.$vs.notify({
                title: "Erreur",
                text: "Une erreur s'est produite",
                color: "danger",
                position: "top-center",
              });
            });
        } else {
          return;
        }
      });
    },
  },
};
</script>
